import { render, staticRenderFns } from "./VoiceRoomControls.vue?vue&type=template&id=7d1ac84d&scoped=true"
import script from "./VoiceRoomControls.vue?vue&type=script&lang=js"
export * from "./VoiceRoomControls.vue?vue&type=script&lang=js"
import style0 from "./VoiceRoomControls.vue?vue&type=style&index=0&id=7d1ac84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1ac84d",
  null
  
)

export default component.exports